import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="main-navbar navbar navbar-expand-lg">
      <div className="nav-container container">
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="mainNav"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
        >
          {/* 👇 tekst umjesto ikone */}
          <span className="custom-toggler-text">MENU</span>
        </button>

        <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id="mainNav">
          <ul className="navbar-nav nav-left">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/order">Order</Link>
            </li>
          </ul>

          <div className="nav-logo mx-auto">
            <Link to="/">
              <img src="/img/cookie2.png" alt="Logo" />
            </Link>
          </div>

          <ul className="navbar-nav nav-right ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/locations">Locations</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/blog">Blog</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
